import PractitionersAddButton from './PractitionersAddButton';
import PractitionerAdd from './PractitionerForm/AddPractitionerFormContainer';
import PractitionerDetails from './PractitionerDetails/PractitionerDetailsContainer';
import PractitionerEdit from './PractitionerForm/EditPractitionerFormContainer';
import PractitionerList from './PractitionersList/PractitionersListContainer';
import PractitionersEmpty from './PractitionersEmpty/PractitionersEmpty';

export { selectPractitioners, selectPractitionersIsLoading } from './Practitioners.selectors';
export { watchActions as watchPractitionersActions } from './Practitioners.saga';
export const PractitionersComponents = {
  add: PractitionerAdd,
  addButton: PractitionersAddButton,
  details: PractitionerDetails,
  edit: PractitionerEdit,
  list: PractitionerList,
  empty: PractitionersEmpty,
};
export { default as DeletePractitionerModal } from './DeletePractitionerModal/DeletePractitionerModal';
